<template>
  <v-container fluid fill-height class="d-flex justify-center align-center">
    <!-- Row untuk form login -->
    <v-row justify="center" align="center" class="w-100">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="pa-6" elevation="12">
          <!-- Menambahkan logo di atas form login -->
          <div class="d-flex justify-center">
            <v-img
              src="@/assets/logo_fli.png"
              alt="Logo"
              max-width="350px"
              max-height="200px"
              class="mb-2"
              contain
            ></v-img>
          </div>

          <!-- Form login -->
          <v-form v-model="valid" @submit.prevent="loginUser">
            <!-- email input -->
            <v-text-field
              label="Email"
              v-model="email"
              :rules="[(v) => !!v || 'Email is required']"
              required
            ></v-text-field>

            <v-text-field
              label="Password"
              v-model="password"
              :rules="[(v) => !!v || 'Password is required']"
              :type="showPassword ? 'text' : 'password'"
              required
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="togglePasswordVisibility"
            ></v-text-field>

            <!-- Submit button -->
            <v-btn
              :disabled="!valid"
              type="submit"
              color="primary"
              class="ma-2"
              block
            >
              Login
            </v-btn>

            <!-- Link ke halaman reset password -->
            <v-btn text @click="goToResetPassword" class="ma-2" block>
              Forgot Password?
            </v-btn>
          </v-form>

          <!-- Snackbar error message -->
          <v-snackbar
            v-model="snackbar"
            color="error"
            top
            multi-line
            timeout="5000"
          >
            {{ errorMessage }}
            <v-btn color="white" @click="snackbar = false">Close</v-btn>
          </v-snackbar>
        </v-card>
      </v-col>
    </v-row>

    <!-- Snackbar Notifications -->
    <snackbarMessage />
  </v-container>
</template>

<script>
import axios from "axios";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";

export default {
  components: {
    snackbarMessage,
  },
  data() {
    return {
      showPassword: false,
      email: "",
      password: "",
      valid: false, // Validasi form
      snackbar: false, // Untuk menampilkan snackbar
      errorMessage: "", // Pesan error untuk snackbar
    };
  },
  methods: {
    loginUser() {
      axios
        .post(`${process.env.VUE_APP_API_URL}/login`, {
          email: this.email,
          password: this.password,
        })
        .then((response) => {
          const token_jwt = response.data.token_jwt;

          // console.log(token_jwt);

          store.dispatch("user/saveJwtToken", token_jwt);

          // Redirect ke halaman dashboard
          window.location.href = `${process.env.VUE_APP_URL}`;
        })
        .catch((error) => {
          let message = "Failed to login !"; // Pesan default jika error

          if (error.response) {
            // Jika ada respons error dari backend
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message; // Pesan error default
          }

          // Menampilkan snackbar dengan status error (merah)
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        });
    },
    // Arahkan ke halaman reset password
    goToResetPassword() {
      this.$router.push("/request-reset-password");
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword; // Toggle password visibility
    },
  },
};
</script>
